import { useEffect, useRef, useState } from "react";
import { useTopLayerMenu } from "./useTopLayerMenu";

/** JOB 3 · WILLIAM (2026-10-15) — the calendar bar's `Options` (its own file: the calendar's
 *  cards have no open state — `calendarDepths`/`calendarWeekList` pin that on `TrainingCalendar.tsx`): a button and a small panel in the TOP LAYER (`useTopLayerMenu`,
 *  the `⋯` menus' one mechanism, so no cell or sticky bar clips it). Not a `menu`: it holds radios and a switch, so it is a
 *  disclosure — `aria-expanded` on the button, a labelled group; Escape or a click outside closes it, focus returns on Escape. */
export function CalendarOptions({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);
  const trigger = useRef<HTMLButtonElement>(null);
  const panel = useRef<HTMLDivElement>(null);
  useTopLayerMenu(open, trigger, panel);
  useEffect(() => {
    if (open) panel.current?.querySelector<HTMLElement>("input, button")?.focus();
  }, [open]);
  return (
    <div className="calendar-options"
         onKeyDown={(e) => { if (e.key === "Escape" && open) { e.stopPropagation(); setOpen(false); trigger.current?.focus(); } }}>
      <button ref={trigger} type="button" className="ht-button calendar-options-trigger" aria-expanded={open}
              aria-controls="calendar-options-panel" onClick={() => { setOpen((o) => !o); }}>
        Options <span aria-hidden="true" className="calendar-options-caret">⌄</span>
      </button>
      {open && (
        <div ref={panel} id="calendar-options-panel" className="calendar-options-panel is-top-layer" role="group" aria-label="Options">
          {children}
        </div>
      )}
      {open && <div className="week-menu-scrim" onClick={() => { setOpen(false); }} aria-hidden="true" />}
    </div>
  );
}
